import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  uploadFileButton: {
    minWidth: 'unset',
    padding: '0',
    alignItems: 'flex-start',

    '&:hover': {
      backgroundColor: 'unset',
    },
  },
}));
